module.exports = __webpack_public_path__ + "img/01.c9d8b1e2.png";